<template>
	<PageLoginPasswordRecoveryForm />
</template>

<script setup lang="ts">
	import { PageTitles } from "@/assets/ts/enums/PageTitles";

	definePageMeta({
		layout: "auth",
		auth: {
			unauthenticatedOnly: true,
			navigateAuthenticatedTo: "/",
		},
	});

	useHead({
		title: PageTitles.PasswordRecovery,
	});
</script>
